import PreviewSettings from 'components/PreviewSettings/PreviewSettings';
import { withPreviewSettingsProps } from 'viewModel/previewSettings/withPreviewSettingsProps';

export default withPreviewSettingsProps(PreviewSettings);
